// <Drawer> — the room-history log, mounted into #log inside the secondary 📜 drawer (the
// .drawer aside + scrim are static scaffold in index.html; only its scrollable contents are
// migrated here). PURE function of `app`: renders the last ~90 room-log lines, exactly as the
// old imperative renderLog() string did — Preact DIFFS instead of clobbering. Emits the SAME
// .msg/.who class names so the grep contract stays green. The history/log living in a drawer
// (not the center) is the deliberate "log is secondary" product direction. See PREACT-MIGRATION.md.
import { html, cx, t } from '../shared.js';

// Source label mirrors the classic: host → 主持人, otherwise blank. AI lines carry NO label —
// a player must not be able to tell which log entries came from an AI seat.
const kindLabel = (kind: LogLine['type']): string =>
  kind === 'host' ? t('drawer.kindHost') : '';

export function Drawer({ app }: { app: AppState }) {
  const blocked: string[] = (app && app.room && (app.room as any).me && (app.room as any).me.blocked) || [];
  const logs: LogLine[] = ((app && app.room && app.room.logs) || []).filter((m: LogLine) => !(m.pid && blocked.includes(m.pid))).slice(-90); // chat of someone you blocked
  return html`
    ${logs.map((m: LogLine, i: number) => html`
      <div class=${cx('msg', m.type)} key=${i}>
        <div class="who"><span>${m.who}</span><span class="small muted">${kindLabel(m.type)}</span></div>
        ${m.text}
      </div>`)}
  `;
}
